import { render } from "./IconGeofence.vue?vue&type=template&id=35ed11c8"
import script from "./IconGeofence.vue?vue&type=script&lang=js"
export * from "./IconGeofence.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__